
import { definitionsFromContext } from "stimulus/webpack-helpers";
import application from "stimulus_application";
import "./sort_by.css";

const context = require.context("./", true, /_controller\.js$/);
application.load(definitionsFromContext(context));
